import { AssigneeDto } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/AssigneeDto';
import { AssigneeType } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/AssigneeType';
import { searchAssignees } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/AssignmentService';
import { State } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/State';
import { AssignmentFolderRights } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments/AssignmentFolderRights';
import { PagingSearchResult } from 'components/inputs/SearchBox';

const AllAssigneeTypes = AssigneeType.Account | AssigneeType.AssignmentFolderRights | AssigneeType.Group | AssigneeType.Role;

export function getInitials(assignee: AssigneeDto) {
  const initials = (assignee.AdditionalData || []).find(data => data.Name === 'Initials');
  return (initials && initials.OutputValue) || '';
}

export function getAssigneePrimaryText(assignee: AssigneeDto) {
  return assignee.PrimaryText;
}

export function getAssigneeSecondaryText(assignee: AssigneeDto) {
  return assignee.SecondaryText;
}

export function getAssigneeType(assignee: AssigneeDto) {
  return assignee.Type;
}

export function getUserEmail(assignee: AssigneeDto) {
  return assignee.SecondaryText;
}

export function getGroupName(assignee: AssigneeDto) {
  return assignee.PrimaryText;
}

export function getFolderRight(assignee: AssigneeDto): AssignmentFolderRights {
  return AssignmentFolderRights[assignee.Id as (keyof typeof AssignmentFolderRights)];
}

export async function search(text: string, loadedCount: number, pageSize: number, types: AssigneeType = AllAssigneeTypes): Promise<PagingSearchResult<AssigneeDto>> {

  const assignees = await searchAssignees({
    assigneeType: types,
    desiredResultCount: pageSize,
    skipCount: loadedCount,
    textToSearch: text,
  });

  return {
    items: assignees,
    //NOTE alex: it is not right way to do that, but works in most cases and it is how it was implemented in MVC ...
    hasNext: assignees.length === pageSize,
  };
}

export function searchWithExclusion(func: typeof search, toExclude: AssigneeDto[]): typeof search {
  return (text: string, loadedCount: number, pageSize: number) => func(text, loadedCount, pageSize).then((result) => ({
    hasNext: result.hasNext,
    items: exclude(result.items, toExclude)
  }));
}

function exclude(items: AssigneeDto[], toExclude: AssigneeDto[]): AssigneeDto[] {
  const excludedIds = (toExclude || []).map((item) => item.Id);
  return items.filter((item) => !excludedIds.includes(item.Id));
}

export function getByStates(assignees: AssigneeDto[], ...states: State[]): AssigneeDto[] {
  return assignees.filter((item) => states.includes(item.State));
}

export function getByType(assignees: AssigneeDto[], type: AssigneeType): AssigneeDto[] {
  return assignees.filter((item) => item.Type === type);
}
